module.exports = __webpack_public_path__ + "static/jade4-b0ba6b861dfc66b23f0b3030dbddddcd.png";